import { Isotype, IconWhatsApp } from './icons';

/* ── Final CTA ────────────────────────────────────────────────────────── */
const FinalCTA = ({ onWhats, onQuote }) => (
  <section className="finalcta">
    <Isotype className="iso" />
    <div className="inner">
      <h2>¿List@ para estrenar?</h2>
      <p>Cuéntanos qué coche quieres y lo hacemos fácil, rápido y digital. Sin sorpresas.</p>
      <div className="btns">
        <button className="b-wa" onClick={onWhats}><IconWhatsApp /> Cotiza por WhatsApp</button>
        <button className="b-ghost" onClick={onQuote}>Cotizar en línea</button>
      </div>
    </div>
  </section>
);

export default FinalCTA;
